import { useState, useCallback } from 'react';
import { getNextSortState, sortCollection } from '../utils/tableSortUtils';

/**
 * Hook for sortable tables in function components.
 */
export function useTableSort(initialField = null, initialDirection = 'asc', accessors = {}) {
    const [sortState, setSortState] = useState({ field: initialField, direction: initialDirection });

    const handleSort = useCallback((field) => {
        setSortState((prev) => getNextSortState(prev.field, prev.direction, field));
    }, []);

    const sortItems = useCallback((items) => {
        return sortCollection(items, sortState.field, sortState.direction, accessors);
    }, [sortState.field, sortState.direction, accessors]);

    return {
        sortField: sortState.field,
        sortDirection: sortState.direction,
        handleSort,
        sortItems,
    };
}
